import { useCallback, useEffect, useRef } from "react";

import _debounce from "lodash/debounce";

import { useGroupByStore } from "../GroupByStoreProvider";
import { selectFilterText } from "../groupBySelectors";

export const useSearchBar = () => {
  const filterText = useGroupByStore(selectFilterText);
  const setFilterText = useGroupByStore((s) => s.setFilterText);

  const debouncedSetFilterText = useRef(
    _debounce((value: string) => setFilterText(value), 400)
  ).current;

  useEffect(() => {
    return () => {
      debouncedSetFilterText.cancel();
    };
  }, [debouncedSetFilterText]);

  const handleSearch = useCallback(
    (value: string) => debouncedSetFilterText(value),
    [debouncedSetFilterText]
  );

  return {
    filterText,
    onFilterChange: handleSearch
  };
};
